import PropTypes from 'prop-types'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { useRelations } from '@hooks/usePublication'

const PublicationListItem = (props) => {
  const {
    callbacks: {
      togglePublicationId,
    },
    publication,
  } = props

  const { title } = publication

  const {
    provider: {
      title: providerTitle,
    },
  } = useRelations(publication)

  return (
    <DashboardModuleListItem
      boxProps={{ paddingX: 0 }}
      secondaryText={providerTitle}
      title={title}
    >
      <DashboardModuleListItem.Actions>
        <DashboardModuleListItem.Icon onClick={() => togglePublicationId()} type="delete" />
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

PublicationListItem.propTypes = {
  callbacks: PropTypes.shape({
    togglePublicationId: PropTypes.func.isRequired,
  }).isRequired,
  publication: PropTypes.object.isRequired,
}

export default PublicationListItem
